import { render, staticRenderFns } from "./EditOpportuniteQuickModal.vue?vue&type=template&id=2d0c7a7d&scoped=true&"
import script from "./EditOpportuniteQuickModal.vue?vue&type=script&lang=ts&"
export * from "./EditOpportuniteQuickModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditOpportuniteQuickModal.vue?vue&type=style&index=0&id=2d0c7a7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c7a7d",
  null
  
)

export default component.exports